var map = {
	"./de.png": 1053,
	"./en.png": 1054,
	"./es.png": 1055,
	"./fr.png": 1056,
	"./ja.png": 1057,
	"./mk.png": 1058,
	"./pt.png": 1059,
	"./tr.png": 1060,
	"./zh.png": 1061
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1052;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1052
// module chunks = 0